(ns teamoesterreich.admin-mode.user.user-card-personal
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as date-h]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]
            [teamoesterreich.admin-mode.modal.info-modal :as info-modal]

            [reagent-material-ui.icons.send-sharp :refer [send-sharp]]
            [reagent-material-ui.icons.location-searching :refer [location-searching]]
            [reagent-material-ui.icons.fireplace :refer [fireplace]]
            [reagent-material-ui.icons.sync :refer [sync]]

            ))



(defonce DEGREES (reduce (fn [c [k n]] (assoc c k n)) {} staticData/DEGREES))
(defonce JOB-STATUS (reduce (fn [c [k n]] (assoc c k n)) {} staticData/JOB-STATUS))
(defonce NATIONALITIES (into {} (sort-by first staticData/NATIONALITIES)))

(defonce GENDER {"M" "Mann"
                 "F" "Frau"
                 "A" "Anderes"})
(defonce CLOTH_SIZE {"XXL" "XXL"
                     "XL"  "XL"
                     "L"   "L"
                     "M"   "M"
                     "S"   "S"
                     "XS"  "XS"})


(defn get-last-login [user]
  (let [devs (:user-devices user)]
    (reduce (fn [c dev]
              ;(log/debug " DEV found" (:device-lastContact dev) ">" c "" (< c (:device-lastContact dev)))
              (if (or (nil? c) (< c (:device-lastContact dev)))
                (:device-lastContact dev)
                c)
              )
            nil
            devs)
    ))


(defn get-status [!actual-user]
  (let [actual-user @!actual-user
        actual-val-fn (fn [key & [def]] (or (get actual-user key) def ""))
        last-login (get-last-login @!actual-user)
        ]

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    3
      :style      {:margin "0"}
      }
     [mui/grid
      {:container false :item true
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/typography "Status"]]

     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }

      [mui/text-field {
                       :style           {:color (if (actual-val-fn :user-profileValid) "#0e2f02" "#8c0e0e")}
                       :fullWidth       true
                       :disabled        true
                       :label           "Profil Status"
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :defaultValue    (if (actual-val-fn :user-profileValid) "Profil ist vollständig"
                                                                               (actual-val-fn :user-profileValidHint))
                       }]

      ]

     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }]

     [mui/grid
      {:container false :item true
       :md        5
       :xs        12
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor "#ffffff"}
                       :type            "date"
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        true
                       :value           (date-h/rest-2-date-field! (actual-val-fn :user-since))
                       :label           "Registriert seit"}]
      ]

     [mui/grid
      {:container false :item true
       :md        5
       :xs        12
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor "#ffffff"}
                       :type            "datetime"
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        true
                       :value           (try (date-h/rest-2-datetime-field! last-login) (catch :default e ""))
                       :label           "Letzter Login"}]
      ]]
    ))



(defn get-personal [!actual-user ALL_DST_LIST DEP_LIST !edit-mode !edited]
  (let [actual-user @!actual-user
        actual-user (assoc actual-user :_user-birthday (date-h/rest-2-date-field! (:user-birthday actual-user)))
        changed-fn (fn [key] (and (get @!edited key) (not= (get actual-user key) (get @!edited key))))
        change-fn (fn [key] (fn [ev] (swap! !edited assoc key (h/event-value ev))))
        actual-val-fn (fn [key & [def]] (or (get @!edited key) (get actual-user key) def ""))
        last-login (get-last-login @!actual-user)
        ]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    3
      :style      {:margin "0"}
      }
     [mui/grid
      {:container false :item true
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/typography "Persönlich"]]


     [mui/grid
      {:container false :item true
       :md        2                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-title) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-title)
                       :onChange        (change-fn :user-title)
                       :label           "Titel"}]
      ]
     [mui/grid
      {:container false :item true
       :md        5                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-firstName) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-firstName)
                       :onChange        (change-fn :user-firstName)
                       :label           "Vorname"}]
      ]
     [mui/grid
      {:container false :item true
       :md        5                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-lastName) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-lastName)
                       :onChange        (change-fn :user-lastName)
                       :label           "Nachname"}]
      ]
     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [:div {:style {:backgroundColor (if (changed-fn :user-gender) "#ffd6d2" "#ffffff")}}
       [mui/form-label
        [:span {:style {:font-size "0.7rem" :lineHeight "16px"}} "Geschlecht "]
        [mui/select
         {:fullWidth true
          :disabled  (not @!edit-mode)
          :value     (actual-val-fn :user-gender)
          :onChange  (change-fn :user-gender)
          }
         (for [[k name] GENDER]
           ^{:key (str "GENDER-" k)} [mui/menu-item {:style {} :value k} name])
         ]]]
      ]

     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :_user-birthday) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "date"
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :_user-birthday)
                       :onChange        (change-fn :_user-birthday)
                       :label           "Geburtsdatum "}]
      ]

     [mui/grid
      {:container false :item true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      (js/console.log "DEP_LIST" (clj->js DEP_LIST))
      [mui/text-field {
                       :fullWidth true
                       :disabled  true
                       :value     (str
                                    (d-organisation/get-dep-4-dest DEP_LIST (str (:user-orgId @!actual-user))) " / "
                                    (or (get ALL_DST_LIST (:user-orgId @!actual-user)) "-keine-"))
                       :label     "Dienststelle"}]
      ]
     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/form-control-label {:style     {:backgroundColor (if (changed-fn :user-rk) "#ffd6d2" "#ffffff")}
                               :label     (str "RK Mitglied")
                               :disabled  (not @!edit-mode)
                               :checked   (if (nil? (:user-rk @!edited))
                                            (if (:user-rk @!actual-user) true false)
                                            (:user-rk @!edited))

                               :onChange  (fn [_ b] (swap! !edited assoc :user-rk b))
                               :placement "start"
                               :control   (r/as-element [mui/checkbox {}])}]
      ]
     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/form-control-label {:style     {:backgroundColor (if (changed-fn :user-tester) "#ffd6d2" "#ffffff")}
                               :label     (str "Tester")
                               :disabled  (not @!edit-mode)
                               :checked   (if (nil? (:user-tester @!edited))
                                            (if (:user-tester @!actual-user) true false)
                                            (:user-tester @!edited))

                               :onChange  (fn [_ b] (swap! !edited assoc :user-tester b))
                               :placement "start"
                               :control   (r/as-element [mui/checkbox {}])}]
      ]
     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [:div {:style {:backgroundColor (if (changed-fn :user-clothSize) "#ffd6d2" "#ffffff")}}
       [mui/form-label
        [:span {:style {:font-size "0.7rem" :lineHeight "16px"}} "Kleidergröße "]
        [mui/select
         {:fullWidth true
          :disabled  (not @!edit-mode)
          :value     (actual-val-fn :user-clothSize)
          :onChange  (change-fn :user-clothSize)
          }
         (for [[k name] CLOTH_SIZE]
           ^{:key (str "CLOTH_SIZE-" k)} [mui/menu-item {:style {} :value k} name])
         ]]]
      ]

     ]))


(defn get-address [!actual-user !edit-mode !edited]
  (let [actual-user @!actual-user
        actual-user (assoc actual-user :_user-birthday (date-h/rest-2-date-field! (:user-birthday actual-user)))
        changed-fn (fn [key] (and (get @!edited key) (not= (get actual-user key) (get @!edited key))))
        change-fn (fn [key] (fn [ev] (swap! !edited assoc key (h/event-value ev))))
        actual-val-fn (fn [key & [def]] (or (get @!edited key) (get actual-user key) def ""))]

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    3
      :style      {:margin "0"}
      }
     [mui/grid
      {:container false :item true
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/typography "Adresse"]]
     [mui/grid
      {:container false :item true
       :md        5                                         ;medium: 960px
       :xs        8                                         ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-street) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-street)
                       :onChange        (change-fn :user-street)
                       :label           "Straße"}]
      ]
     [mui/grid
      {:container false :item true
       :md        2                                         ;medium: 960px
       :xs        4                                         ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-streetNo) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-streetNo)
                       :onChange        (change-fn :user-streetNo)
                       :label           "Nummer"}]
      ]
     [mui/grid
      {:container false :item true
       :md        3                                         ;medium: 960px
       :xs        4                                         ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-zip) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-zip)
                       :onChange        (change-fn :user-zip)
                       :label           "Postleitzahl"}]
      ]
     [mui/grid
      {:container false :item true
       :md        4                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-city) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-city)
                       :onChange        (change-fn :user-city)
                       :label           "Ort"}]
      ]

     ]))

(defn get-contact [!actual-user !edit-mode !edited]
  (let [actual-user @!actual-user
        actual-user (assoc actual-user :_user-birthday (date-h/rest-2-date-field! (:user-birthday actual-user)))
        changed-fn (fn [key] (and (get @!edited key) (not= (get actual-user key) (get @!edited key))))
        change-fn (fn [key] (fn [ev] (swap! !edited assoc key (h/event-value ev))))
        actual-val-fn (fn [key & [def]] (or (get @!edited key) (get actual-user key) def ""))]

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    3
      :style      {:margin "0"}
      }
     [mui/grid
      {:container false :item true
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/typography "Kontakt"]]
     [mui/grid
      {:container false :item true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-phoneNumber) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-phoneNumber)
                       :onChange        (change-fn :user-phoneNumber)
                       :label           "Mobilnummer"}]
      ]
     [mui/grid
      {:container false :item true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "5px"}
       }
      [mui/text-field {:style           {:backgroundColor (if (changed-fn :user-email) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :disabled        (not @!edit-mode)
                       :value           (actual-val-fn :user-email)
                       :onChange        (change-fn :user-email)
                       :label           "Email"}]
      ]

     ]))

(defn get-language-string [u]
  (try
    (reduce (fn [c le]
              (let [[l q] (clojure.string/split le #"\#")]
                (if (= q "del")
                  c
                  (str c l " " (or (get staticData/LANGUAGE_LEVELS_ABBR q) q) ", "))))
            ""
            (clojure.string/split (:user-language u) #"\|"))
    (catch :default e "")))

(defn get-driver-string [u]
  (let [l (conj [] (when (:user-fsA u) "A") (when (:user-fsB u) "B") (when (:user-fsBE u) "BE") (when (:user-fsC1 u) "C1") (when (:user-fsC1E u) "C1E") (when (:user-fsC u) "C") (when (:user-fsCE u) "CE") (when (:user-fsD1 u) "D1") (when (:user-fsD u) "D") (when (:user-fsL u) "L"))]
    ;(log/debug "driver-string " l)
    (reduce (fn [c e] (str c (when e (if (= c "") e (str ", " e))))) "" l)))

(defn get-qualifications [!actual-user !edit-mode]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "flex-start"
    :alignItems "flex-start"
    :spacing    3
    :style      {}
    }
   [mui/grid
    {:container false :item true
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/typography "Qualifikation"]]

   [mui/grid
    {:container false :item true
     :md        12                                          ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/text-field {
                     :fullWidth    true
                     :disabled     true                     ;(not @!edit-mode)
                     :defaultValue (get-language-string @!actual-user)
                     :label        "Sprachen"}]]

   [mui/grid
    {:container false :item true
     :md        6                                           ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/text-field {
                     :fullWidth true
                     :disabled  true                        ;(not @!edit-mode)
                     ;:defaultValue (str (get DEGREES (:user-ausbildungen @!actual-user)))
                     :label     "Studium"}]
    ]
   [mui/grid
    {:container false :item true
     :md        6                                           ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/text-field {
                     :fullWidth true
                     :disabled  true                        ;(not @!edit-mode)
                     ;:defaultValue (str (get JOB-STATUS (:user-beruf @!actual-user)))
                     :label     "Beschäftigungsstand"}]]
   [mui/grid
    {:container false :item true
     :md        6                                           ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/text-field {
                     :fullWidth    true
                     :disabled     true                     ;(not @!edit-mode)
                     :defaultValue (str (:user-sachverstaendiger @!actual-user))
                     :label        "Experte"}]
    ]
   [mui/grid
    {:container false :item true
     :md        6                                           ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "5px"}
     }
    [mui/text-field {
                     :fullWidth    true
                     :disabled     true                     ;(not @!edit-mode)
                     :title        (str (get-driver-string @!actual-user))
                     :defaultValue (str (get-driver-string @!actual-user))
                     :label        "Führerschein"}]]

   ])


(defn get-it [!actual-user !st]
  (let [!edit-mode (r/cursor !st [:edit])
        !edited (r/cursor !st [:edited])
        !show-save (r/cursor !st [:show-save])
        !show-send-push (r/cursor !st [:show-no-push])
        !show-send-sms (r/cursor !st [:show-send-sms])
        !show-send-mail (r/cursor !st [:show-no-mail])
        !show-message-sent (r/cursor !st [:show-sent])
        !show-sync-requested (r/cursor !st [:sync-requested])
        !show-reset-location-modal? (r/cursor !st [:show-reset-location])
        !show-reset-orgId-modal? (r/cursor !st [:show-reset-orgId])
        tomId (:user-tomId @!actual-user)
        name (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))

        _ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        ALL_DST_LIST (or (into {} (d-organisation/get-all-multi-filter-list @!organisations)) {})
        DEP_LIST (or (into {} (d-organisation/get-lv-filter-list @!organisations)) {})
        ]

    [mui/card {:style {:textAlign "left"}}
     [mui/card-content

      [info-modal/info-modal !show-message-sent "Diese Nachricht wurde gesendet!" "Ok" (fn [])]
      [info-modal/info-modal !show-sync-requested "Synchronisation angestossen!" "Ok" (fn [])]

      [(send-message-modal/email-template-modal !show-send-mail "user" (str "Email erstellen und an " name " senden:") "senden"
                                                (fn [subject email from] (d-user/email-to-tomIds [tomId] subject email from #(reset! !show-message-sent @!show-send-mail)))
                                                nil
                                                (fn [subject email from] (d-user/email-to-tomIds [tomId] subject email from #(reset! !show-message-sent @!show-send-mail) :self))
                                                )]


      [(send-message-modal/sms-modal !show-send-sms (str "SMS erstellen und an " name " senden:") "senden"
                                     (fn [message] (d-user/sms-to-tomIds [tomId] message #(reset! !show-message-sent true))))]

      [(send-message-modal/push-modal !show-send-push (str "Push erstellen und an " name " senden:") "senden"
                                      (fn [message] (d-user/push-to-tomIds [tomId] message #(reset! !show-message-sent true))))]


      [are-you-sure-modal/are-you-sure-modal !show-reset-location-modal?
       (str "Willst du wirklich diese Adresse: \"" (:user-street @!actual-user) " " (:user-streetNo @!actual-user) " " (:user-zip @!actual-user) " " (:user-city @!actual-user) "\" neu lokalisieren?")
       "lokalisieren"
       (fn []
         (d-user/>reset-location (:user-tomId @!actual-user)
                                 (fn []
                                   (reset! !edited {})
                                   (reset! !edit-mode false)
                                   (d-user/actual-user-invalidate !actual-user)
                                   )))]

      [are-you-sure-modal/are-you-sure-modal !show-reset-orgId-modal?
       (str "Willst du wirklich diesen Nutzer die Dienststelle neu zuordnen?")
       "zuordnen"
       (fn []
         (d-user/>reset-orgId (:user-tomId @!actual-user)
                              (fn []
                                (reset! !edited {})
                                (reset! !edit-mode false)
                                (d-user/actual-user-invalidate !actual-user)
                                )))]



      [are-you-sure-modal/are-you-sure-modal !show-save
       (str "Willst du die Änderungen an diesem Teilnehmer `" (:user-firstName @!actual-user) " " (:user-lastName @!actual-user) "` wirklich speichern?")
       "Ok"
       (fn []
         (d-user/>user-edit-field (:user-uuid @!actual-user)
                                  (merge @!edited
                                         (when-let [birthday (:_user-birthday @!edited)] {:user-birthday (date-h/date-field-2-rest birthday)}))
                                  (fn []
                                    (reset! !edited {})
                                    (reset! !edit-mode false)
                                    ;(d-user/actual-user-invalidate !actual-user)
                                    ))
         )]
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "space-around"
        :alignItems "flex-start"
        :spacing    3
        }

       [mui/grid
        {:container false :item true
         :xl        6                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        (get-status !actual-user)
        (get-personal !actual-user ALL_DST_LIST DEP_LIST !edit-mode !edited)
        ]

       [mui/grid
        {:container false :item true
         :xl        6                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        (get-qualifications !actual-user !edit-mode)
        ]

       [mui/grid
        {:container false :item true
         :xl        6                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        (get-address !actual-user !edit-mode !edited)
        ]
       [mui/grid
        {:container false :item true
         :xl        6                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        (get-contact !actual-user !edit-mode !edited)
        ]

       ]
      ]
     (if (not @!edit-mode)
       [mui/card-actions

        [mui/button {
                     :color    "secondary"
                     :disabled (not (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user)))
                     :onClick  #(reset! !edit-mode true)
                     } "Bearbeiten"]
        [mui/button {:startIcon (r/as-element [send-sharp])
                     :onClick   #(reset! !show-send-mail true)
                     } "Email senden"]
        [mui/button {:startIcon (r/as-element [send-sharp])
                     :onClick   #(reset! !show-send-sms true)
                     } "SMS senden"]
        (if (d-user/is-pushable @!actual-user)
          [mui/button {:startIcon (r/as-element [send-sharp])
                       :onClick   #(reset! !show-send-push true)
                       } "Push senden"]
          [mui/chip {:label "Push nicht möglich keine App"}])

        (when (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user))
          [mui/button {:startIcon (r/as-element [location-searching])
                       :onClick   #(reset! !show-reset-location-modal? true)
                       } "neu lokalisieren"]
          )

        [mui/button {:startIcon (r/as-element [sync])
                     :onClick   (fn []
                                  (d-user/>user-fb-sync-request (:user-tomId @!actual-user))
                                  (reset! !show-sync-requested true))
                     } "App sync"]

        (when (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user))
          [mui/button {:startIcon (r/as-element [fireplace])
                       :onClick   #(reset! !show-reset-orgId-modal? true)
                       } "Dienststelle automatisch zuordnen"]
          )
        ]

       [mui/card-actions

        [mui/button {
                     :color    "secondary"
                     :variant  "contained"
                     :disabled (not (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user)))
                     :onClick  (fn []
                                 (reset! !edited {})
                                 (reset! !edit-mode false))
                     } "Abbrechen"]
        (when (reduce (fn [c [k v]] (or c (not= (get @!actual-user k) v))) false @!edited)
          [mui/button {
                       :color    "primary"
                       :variant  "contained"
                       :disabled (not (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user)))
                       :onClick  #(reset! !show-save true)
                       } "Speichern"])

        ]
       )
     ]))







